Vue.component("pagelistinmemory-item",
  {
    template: "#pagelistinmemory-template",
    props:
    {
      id: { type: String, required: true },
      name: { type: String, required: true },
      listUrl: { type: String, required: false },
      headers: { type: Object, required: false },
      noItemsMessage: { type: String, required: true },
      items: { type: Array, required: false, default: [] },
      perPage: { type: Number, required: true },
      page: { type: Number, required: true },
      hideIfEmpty: { type: Boolean, required: false, default: false },
      itemInView: { type: Number, required: false, default: 0 }
    },
    data: function()
    {
      return { pageShown: 0, pages: 0, count: 0, itemInfo: [], inView: 0 };
    },
    created: function()
    {
      if (this.items !== undefined && this.items !== null && this.items.constructor === Array &&
          this.perPage > 0 && this.page > 0)
      {
        var start = (this.page - 1) * this.perPage;

        for (var i = 0; i < this.items.length; i++)
        {
          this.itemInfo.push({ show: false });
        }
      
        this.count = this.items.length;
        this.pages = Math.ceil(this.count / this.perPage);
        this.pageShown = this.page;
        this.inView = start;

        if (this.page > this.pages)
        {
          start = 0;
          this.inView = 0;
          this.pageShown = this.pages;
        }

        for (var i = start; i < this.perPage; i++)
        {
          this.itemInfo[i].show = true;
        }
      }
    },
    watch:
    {
//      page: function(newValue, oldValue)
//      {
//        console.log("page watcher firing " + newValue + ", " + oldValue);
//
//        if (newValue > 0 && newValue !== oldValue && newValue !== this.pageShown)
//        {
//          console.log("page watcher updating item show ");
//
//          var start = (this.pageShown - 1) * this.perPage;
//
//          for (var i = start; i < (this.pageShown * this.perPage) && i < this.count; i++)
//          {
//            this.itemInfo[i].show = false;
//          }
//
//          start = (newValue - 1) * this.perPage;
//
//          for (var i = start; i < (newValue * this.perPage) && i < this.count; i++)
//          {
//            this.itemInfo[i].show = true;
//          }
//          
//          this.pageShown = newValue;
//        }
//      },
      perPage: function(newValue, oldValue)
      {      
        console.log("perpage watcher firing " + newValue + ", " + oldValue);
        
        if (newValue > 0 && newValue !== oldValue)
        {
          var inViewPage = Math.ceil((this.inView + 1) / newValue);
          var start = (this.pageShown - 1) * oldValue;

          console.log("inview " + this.inView);
          console.log("inviewpage " + inViewPage);

          for (var i = start; i < (start + oldValue) && i < this.count; i++)
          {
            console.log("hiding index " + i);
            this.itemInfo[i].show = false;
          }

          start = (inViewPage - 1) * newValue;

          for (var i = start; i < (start + newValue) && i < this.count; i++)
          {
            console.log("showing index " + i);
            this.itemInfo[i].show = true;
          }
          
          this.pages = Math.ceil(this.count / this.perPage);

          if (this.pageShown !== inViewPage)
          {
            this.pageShown = inViewPage;
            this.$emit("page-shown", { page: this.pageShown, perPage: this.perPage, inView: this.inView, replace: true });
          }
        }
      },
      itemInView: function(newValue, oldValue)
      {
        console.log("item in view watcher firing " + newValue + ", " + oldValue);
        
        if (newValue > -1 && newValue !== oldValue && newValue <= this.count)
        {
          var inViewPage = Math.ceil((newValue + 1) / this.perPage);  

          this.inView = newValue;

          if (inViewPage !== this.pageShown)
          {
            this.showPage(inViewPage, true);
          }
        }
      }
    },
    computed:
    {
      hasItems: function ()
      {
        return this.count > 0;
      },
      canPage: function ()
      {
        return this.pages > 1;
      },
      onFirstPage: function ()
      {
        return this.pageShown === 1;
      },
      onLastPage: function ()
      {
        return this.pageShown === this.pages;
      }
    },
    methods:
    {
      showPage: function(nextPage, keepInView)
      {
        console.log("show page " + nextPage + ", " + keepInView);

        if (nextPage !== this.pageShown && nextPage > 0 && nextPage <= this.pages)
        {
          var start = (this.pageShown - 1) * this.perPage;

          for (var i = start; i < (this.pageShown * this.perPage) && i < this.count; i++)
          {
            this.itemInfo[i].show = false;
          }
          
          start = (nextPage - 1) * this.perPage;

          for (var i = start; i < (nextPage * this.perPage) && i < this.count; i++)
          {
            this.itemInfo[i].show = true;
          }
          
          if (!keepInView)
          {
            this.inView = start;
          }

          this.pageShown = nextPage;
          this.$emit("page-shown", { page: this.pageShown, perPage: this.perPage, inView: this.inView, replace: false });
        }
      },
      
      gotoFirstPage: function () { this.showPage(1, false);},
      gotoPrevPage: function () { this.showPage(this.pageShown - 1, false); },
      gotoNextPage: function () { this.showPage(this.pageShown + 1, false); },
      gotoLastPage: function () { this.showPage(this.pages, false); }
    }
  });

